import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SynthLayer from "@/components/SynthLayer";
import Pareto from "@/components/Pareto";
import DossierCard from "@/components/DossierCard";
import IntelLayer from "@/components/IntelLayer";
import Newsletter from "@/components/Newsletter";
import Pricing from "@/components/Pricing";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#030305]" data-testid="landing-page">
      <Header />
      <Hero />
      <SynthLayer />
      <Pareto />
      <DossierCard />
      <IntelLayer />
      <Newsletter />
      <Pricing />
      <Footer />
    </div>
  );
}
